module.exports = __webpack_public_path__ + "img/image10.45acf67e.png";